/*
 * Suggestion counting (3 Oct 2026). Aaron: "add some analytics so we can build up a picture of what sells best ...
 * all of it should only collect once the user clicks accept". Plan: Dropbox/Shopify/RECOMMENDATIONS_ANALYTICS_PLAN.md.
 *
 * Rows counted: "Goes well with this" + "Similar items" (sections/related-products.liquid, data-jhr-recs-row) and the
 * basket's "Riders also added" (snippets/jhr-cart-upsells.liquid, data-jhr-recs-row="basket").
 * For each suggested product: shown (half of the card on screen), clicked (its link tapped), added (put in the basket
 * after coming from a suggestion). Sent in small batches to /apps/jhr/reco - counts only, no visitor id.
 *
 * NOTHING happens until the shopper has said yes to analytics cookies: no counts are sent, nothing is kept in the
 * browser and no hidden tag is added. With consent, the product a shopper came from is kept for 2 hours in this tab
 * only (sessionStorage "jhr_reco_from"), so an add on that product's page can carry the hidden basket-line tag
 * _jhr_from = "<row>:<product it was suggested under>" - which is how real sales are matched to the row afterwards.
 */
(function () {
  'use strict';
  if (window.jhrReco) return;

  var ENDPOINT = '/apps/jhr/reco';
  var KEY = 'jhr_reco_from';
  var MAX_AGE = 2 * 36e5;
  var queue = [];
  var timer = null;
  var shown = {};
  var io = null;
  var started = false;

  function allowed() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!(p && typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  function flush() {
    clearTimeout(timer); timer = null;
    if (!queue.length) return;
    var body = JSON.stringify({ ev: queue.splice(0, 60) });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) { /* fall through to fetch */ }
    try { fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, credentials: 'same-origin', headers: { 'Content-Type': 'text/plain' } }); } catch (e) { /* counting never breaks the page */ }
  }

  function push(r, s, t, e) {
    if (!allowed() || !r || !s || !t || String(s) === String(t)) return;
    queue.push({ r: r, s: String(s), t: String(t), e: e });
    if (queue.length >= 50) flush();
    else if (!timer) timer = setTimeout(flush, 4000);
  }

  function readMarks() {
    try { return JSON.parse(window.sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function mark(t, r, s) {
    if (!allowed()) return;
    try {
      var m = readMarks();
      m[String(t)] = { r: r, s: String(s), at: Date.now() };
      var keys = Object.keys(m);
      if (keys.length > 20) {
        keys.sort(function (a, b) { return m[a].at - m[b].at; }).slice(0, keys.length - 20).forEach(function (k) { delete m[k]; });
      }
      window.sessionStorage.setItem(KEY, JSON.stringify(m));
    } catch (e) { /* storage blocked: nothing kept */ }
  }
  function markFor(t) {
    var x = readMarks()[String(t)];
    return x && Date.now() - x.at < MAX_AGE ? x : null;
  }

  // row, source product and suggested product for any element inside a suggestion card
  function cardInfo(el) {
    var row = el && el.closest ? el.closest('[data-jhr-recs-row]') : null;
    if (!row) return null;
    var card = el.closest('[data-jhr-pid], product-block[data-product-id]');
    if (!card || !row.contains(card)) return null;
    var t = card.getAttribute('data-jhr-pid') || card.getAttribute('data-product-id');
    var s = card.getAttribute('data-jhr-source');
    if (!s) {
      var holder = row.closest('[data-jhr-source-pid]');
      s = holder ? holder.getAttribute('data-jhr-source-pid') : null;
    }
    var r = row.getAttribute('data-jhr-recs-row');
    return t && s && r ? { r: r, s: s, t: t } : null;
  }

  function watchCards() {
    if (!io) return;
    var cards = document.querySelectorAll('[data-jhr-recs-row] [data-jhr-pid], [data-jhr-recs-row] product-block[data-product-id]');
    Array.prototype.forEach.call(cards, function (c) {
      if (c.__jhrRecoWatched) return;
      c.__jhrRecoWatched = true;
      io.observe(c);
    });
  }

  // ---- the product page this shopper came to from a suggestion: tag its add-to-basket and count the add
  function productMeta() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    return m && m.id ? m : null;
  }
  function variantOf(meta, id) {
    if (!meta || !meta.variants) return false;
    for (var i = 0; i < meta.variants.length; i++) if (String(meta.variants[i].id) === String(id)) return true;
    return false;
  }
  function tagProductForms() {
    var meta = productMeta();
    if (!meta || !allowed()) return;
    var from = markFor(meta.id);
    if (!from) return;
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
      var idInput = f.querySelector('[name="id"]');
      if (!idInput || !variantOf(meta, idInput.value) || f.querySelector('input[name="properties[_jhr_from]"]')) return;
      if (f.closest('[data-jhr-recs-row]')) return;
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'properties[_jhr_from]';
      h.value = from.r + ':' + from.s;
      f.appendChild(h);
    });
  }

  function start() {
    if (started || !allowed()) return;
    started = true;

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var x = cardInfo(en.target);
          io.unobserve(en.target);
          if (!x) return;
          var k = x.r + '|' + x.s + '|' + x.t;
          if (shown[k]) return;
          shown[k] = true;
          push(x.r, x.s, x.t, 'shown');
        });
      }, { threshold: 0.5 });
      watchCards();
      // rows fill in after the page (Similar items, the basket row): watch for new cards
      if ('MutationObserver' in window) {
        var pending = false;
        new MutationObserver(function () {
          if (pending) return;
          pending = true;
          setTimeout(function () { pending = false; watchCards(); }, 300);
        }).observe(document.body, { childList: true, subtree: true });
      }
    }

    document.addEventListener('click', function (ev) {
      // a link (photo / name) or a button on the card ("Choose options", quick buy) - either is a tap on the suggestion
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href], button') : null;
      if (!a) return;
      var x = cardInfo(a);
      if (!x) return;
      push(x.r, x.s, x.t, 'clicked');
      mark(x.t, x.r, x.s);
    }, true);

    document.addEventListener('on:cart:add', function (ev) {
      var meta = productMeta();
      var vid = ev && ev.detail && ev.detail.variantId;
      if (!meta || !vid || !variantOf(meta, vid)) return;
      var from = markFor(meta.id);
      if (from) push(from.r, from.s, meta.id, 'added');
    });

    tagProductForms();
    // basket rows drawn before counting could start (the 50/50 basket test counts each version's visits)
    Array.prototype.forEach.call(document.querySelectorAll('[data-jhr-rendered]'), function (el) { window.jhrReco.view(el); });
  }

  window.jhrReco = {
    allowed: allowed,
    flush: flush,
    // used by the basket row's own "+ Add" (snippets/jhr-cart-upsells.liquid)
    added: function (r, s, t) { push(r, s, t, 'added'); },
    tag: function (r, s) { return allowed() && r && s ? r + ':' + s : null; },
    // one visit to a row (the basket test's "out of how many baskets"): counted once per page, consent only
    view: function (el) {
      if (!el || el.__jhrViewed || !started || !allowed()) return;
      var r = el.getAttribute('data-jhr-recs-row');
      if (!r) return;
      el.__jhrViewed = true;
      queue.push({ r: r, s: '0', t: '0', e: 'view' });
      if (!timer) timer = setTimeout(flush, 4000);
    },
  };

  window.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  // the shopper answers the cookie banner on this page
  document.addEventListener('visitorConsentCollected', function (e) {
    if (e && e.detail && e.detail.analyticsAllowed) setTimeout(start, 0);
  });

  function boot() {
    if (window.Shopify && window.Shopify.customerPrivacy) { start(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) start(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
